<p-confirmDialog key="bus" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="confirmbusdelete" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Bus</button>
		<button [disabled]="IsLoading() == true || CanEdit() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Bus</button>
		<button [disabled]="IsLoading() == true || CanDelete() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">
			Toggle Bus
		</button>
		<button [disabled]="IsLoading() == true || CanDelete() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">
			Delete Bus
		</button>

		<button [disabled]="IsLoading() == true" class="btn btn-success" style="margin-left: 5px" (click)="onExport()">Export</button>
		<button [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onImport()">Import</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstBus"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedBus"
		dataKey="BusID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--BusNbr-->
				<th>
					<p-columnFilter id="Bus_BusNbrFilter" type="text" field="BusNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--BusDesc-->
				<th>
					<p-columnFilter id="Bus_BusDescFilter" type="text" field="BusDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--RouteCount-->
				<th>
					<!-- <p-columnFilter type="text" field="RouteCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--StudentCount-->
				<th>
					<!-- <p-columnFilter type="text" field="StudentCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--DefinedBy-->
				<th>
					<p-columnFilter id="Bus_DefinedByDescFilter" field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstDefinedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter id="Bus_ActiveDescFilter" field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="BusNbr">Number<p-sortIcon field="BusNbr"></p-sortIcon></th>
				<th pSortableColumn="BusDesc">Description<p-sortIcon field="BusDesc"></p-sortIcon></th>
				<th pSortableColumn="RouteCount">Total Routes<p-sortIcon field="RouteCount"></p-sortIcon></th>
				<th pSortableColumn="StudentCount">Total Students<p-sortIcon field="StudentCount"></p-sortIcon></th>
				<th pSortableColumn="DefinedByID">Defined By<p-sortIcon field="DefinedByID"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Bus>
			<tr [pSelectableRow]="Bus" (dblclick)="onRowDblClick(Bus)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Bus["BusNbr"] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Bus.DefinedByID <= 2 ? 'Blue' : 'Black'">
					{{ Bus["BusDesc"] }}
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Bus[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Bus.DefinedByID > 2 ? 'Black' : 'Red'">
					{{ Bus["DefinedByDesc"] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Bus.Active == true ? 'Black' : 'Red'">
					{{ Bus["ActiveDesc"] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
